import React from 'react';
import "./App.css";
import "./styles/swg.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Context
import { LanguageProvider } from './context/LanguageContext';

// Layout
import Layout from './components/layout/Layout';
import ScrollToTop from './components/ScrollToTop';
import useEmergentBadgeBlend from './hooks/useEmergentBadgeBlend';

// Pages
import HomePage from './pages/HomePage';
import SplashPage from './pages/SplashPage';
import AboutPage from './pages/AboutPage';
import EcosystemPage from './pages/EcosystemPage';
import SubsidiaryPage from './pages/SubsidiaryPage';
import CareersPage from './pages/CareersPage';
import PartnershipsPage from './pages/PartnershipsPage';
import ContactPage from './pages/ContactPage';
import NotFoundPage from './pages/NotFoundPage';
import { useLocation } from 'react-router-dom';

function AppLayout({ children }) {
  const location = useLocation();
  // Splash page should render full-screen without the standard Header/Footer
  if (location.pathname === '/') {
    return <>{children}</>;
  }
  return <Layout>{children}</Layout>;
}

function App() {
  useEmergentBadgeBlend();
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <ScrollToTop />
          <AppLayout>
            <Routes>
              <Route path="/" element={<SplashPage />} />
              <Route path="/home" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/ecosystem" element={<EcosystemPage />} />
              <Route path="/subsidiary/:id" element={<SubsidiaryPage />} />
              <Route path="/careers" element={<CareersPage />} />
              <Route path="/partnerships" element={<PartnershipsPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </AppLayout>
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
